__turbopack_context__.v({
  "copied": "_5F_Y8q_copied",
  "share": "_5F_Y8q_share",
  "socials": "_5F_Y8q_socials",
  "tooltip": "_5F_Y8q_tooltip",
  "tooltip-text": "_5F_Y8q_tooltip-text",
});
